<script type="text/jsx">
/* eslint-disable vue/require-prop-types */
export default {
    functional: true,
    props: ['active'],

    render(h, { props, data, children }) {
        return <div
            class={`ui-picker-item cursor-pointer rounded px-sm py-xs hover:bg-azure hover:text-white hover:font-semibold ${props.active ? 'bg-gray' : ''}`}
            { ...data }>
            { children }
        </div>;
    },
};
</script>
